import Model from './model.js';

export default class PayrollIntegration extends Model {
    urlRoot() { return '/PayrollIntegrations'; }

    defaults() {
        return {
            remoteId: null,
            syncedAt: new Date()
        };
    }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
    }

    constraints() {
        return {
            companyId: {presence: true},
            integrationId: {presence: true}
        };
    }
}



// WEBPACK FOOTER //
// ./app/new-models/payroll-integration.js